import { useFilters } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { metricKeyIs360MapAtom } from '@/atoms/queries/metric';

/* this hook uses the currently selected metric from the 
metricKeyAtom and checks against our map of metrics
whether it's a 360 metric */
export const useIsSelectedMetric360 = () => {
  const [{ metric: metricKey }] = useFilters('main');
  const metricKeyIs360Map = useAtomValue(metricKeyIs360MapAtom);

  /* this checks that 1) we have a metricKey and 2) it exists in the map */
  return !!(metricKey && metricKeyIs360Map[metricKey]);
};
